/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the Tocsoft.GraphQLCodeGen toolchain https://github.com/tocsoft/GraphQLCodeGen
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {HttpClient} from 'aurelia-fetch-client';
import {inject} from 'aurelia-framework';
import { apiUrl } from '../../constants'

interface fetchClient {
    fetch(url: RequestInfo, init: RequestInit): Promise<Response>
}

class GraphQLResponse
{
    data: any
    errors: Array<{ message: string }>
}

function ApproveEvidenceError(message:string, httpResponse:Response, graphqlResponse?: GraphQLResponse) {
    this.name = 'ApproveEvidenceError';
    this.message = message || 'Error fetching graphql response';
    this.stack = (new Error()).stack;
    this.httpResponse = httpResponse;
    if(graphqlResponse && graphqlResponse.errors){
        this.errors = graphqlResponse.errors.map(x=>x.message);
    }
  }
  ApproveEvidenceError.prototype = Object.create(Error.prototype);
  ApproveEvidenceError.prototype.constructor = ApproveEvidenceError;
  
export { ApproveEvidenceError }

@inject(HttpClient, apiUrl)
export class ApproveEvidenceClient {

    constructor(public client: fetchClient, public url: string) { }
	
	approveEvidence_approveEvidence(	req? :ApproveEvidenceRequestInput) : Promise<ApproveEvidenceApproveEvidenceResult>{
        return this.client.fetch(this.url, {
            method : 'POST',
            body : JSON.stringify({
                query : `mutation approveEvidence($req: ApproveEvidenceRequestInput) {
  approveEvidence(request: $req) {
    success
    isLocked
  }
}
`,
                variables : {
					req : req ,
                }
            })
        }).then(response=>{
            if(response.status != 200){
                // error result
                throw new ApproveEvidenceError("http error running 'approveEvidence_approveEvidence', see httpResponse for more details.", response)
            }else{
                return response.json().then((json:GraphQLResponse)=>{
                    
                    if(json.errors && json.errors.length > 0){
                        throw new ApproveEvidenceError("graphql error(s) running 'approveEvidence_approveEvidence', see errors collection fro more details", response, json)
                    }

                    const result: any = ApproveEvidenceApproveEvidenceResult.fromJS(json.data);                
                    
                    return result;
                })
            }
        })
    }	
}

export class ApproveEvidenceRequestInput {
		adminNotes? :string;
		approveDecision :boolean;
		evidenceId? :string;
		id? :string;
		ownerId? :string;

    static fromJS(json:any):ApproveEvidenceRequestInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ApproveEvidenceRequestInput();

	result.adminNotes = json["adminNotes"];
	result.approveDecision = json["approveDecision"];
	result.evidenceId = json["evidenceId"];
	result.id = json["id"];
	result.ownerId = json["ownerId"];

        return result;
    }
}

export class ApproveEvidenceApproveEvidenceResult {
		approveEvidence? :SuccessResultResult;

    static fromJS(json:any):ApproveEvidenceApproveEvidenceResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ApproveEvidenceApproveEvidenceResult();

result.approveEvidence= SuccessResultResult.fromJS(json["approveEvidence"]);

        return result;
    }
}

export class SuccessResultResult {
		success :boolean;
		isLocked :boolean;

    static fromJS(json:any):SuccessResultResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new SuccessResultResult();

	result.success = json["success"];
	result.isLocked = json["isLocked"];

        return result;
    }
}


